<template>
    <el-menu ref="cpMenu" theme="light" width="auto" @select="goTo" :default-active="$route.name" style="margin-bottom: 60px;">
        <el-menu-item index="Index">
        <i class="el-icon-menu"></i>工作台</el-menu-item>
        <el-submenu index="withdrawall">
            <template slot="title">
                <i class="el-icon-menu"></i>货代订单<Badge :count="waybillCount"></Badge>
            </template>
            <el-menu-item index="WaybillTypeList">仓库订单
            </el-menu-item>
            <el-menu-item index="WaybillToOutgoingList">待出库订单<Badge :count="toOutgoingCount"></Badge>
            </el-menu-item>
            <el-menu-item index="WaybillToSignList">签收中订单<Badge :count="toSignCount"></Badge>
            </el-menu-item>
            <el-menu-item index="WaybillOutgoingList">已出库订单
            </el-menu-item>
            <el-menu-item index="WaybillCancelList">已取消订单
            </el-menu-item>
            <el-menu-item index="WaybillErrorList">异常问题订单
            </el-menu-item>
            <el-menu-item index="WaybillTodoList">全部订单</el-menu-item>
        </el-submenu>
        <el-submenu index="withdrawallexpress">
            <template slot="title">
                <i class="el-icon-menu"></i>货代包裹<Badge :count="waybillExpressCount"></Badge>
            </template>
            <el-menu-item index="WaybillExpressTypeList">仓库包裹</el-menu-item>
            <el-menu-item index="WaybillExpressTodoList">待签收包裹<Badge :count="waybillExpressCount"></Badge>
            </el-menu-item>
            <el-menu-item index="WaybillExpressOkList">已签收包裹
            </el-menu-item>
            <el-menu-item index="WaybillExpressList">全部包裹
            </el-menu-item>
        </el-submenu>
        <el-menu-item index="ExpressBackList">
        <i class="el-icon-menu"></i>快递退件 <Badge :count="expressBackCount"></Badge>
        </el-menu-item>
        <el-submenu index="storageManage">
            <template slot="title">
                <i class="el-icon-menu"></i>仓储管理<Badge :count="billCount"></Badge>
            </template>
            <el-menu-item index="ShelvesLocationList">
            库位管理
            </el-menu-item>
            <el-menu-item index="StorageProductList">
            商品管理
            </el-menu-item>
            <el-menu-item index="StorageBillList">
            入库单处理<Badge :count="billCount"></Badge>
            </el-menu-item>
        </el-submenu>
        <el-submenu index="dataManage" v-if="$store.state.perms.perms">
            <template slot="title">
                <i class="el-icon-menu"></i>数据统计
            </template>
            <el-menu-item index="WaybillDataReport">
            货代数据
            </el-menu-item>
            <el-menu-item index="WaybillUserReport">
            业务数据
            </el-menu-item>
        </el-submenu>
          <el-submenu index="gatherManage">
            <template slot="title">
                <i class="el-icon-menu"></i>集运管理
            </template>
            <el-menu-item index="GatherRecordList">
            集运记录
            </el-menu-item>
           
            <el-menu-item index="FreightTplList">
            运费模板
            </el-menu-item>
        </el-submenu>  
    </el-menu>
</template>
<script>
export default {
    name: 'CpMenu',
    data() {
        return {
            waybillExpressCount: 0,
            waybillCount: 0,
            toSignCount: 0,
            toOutgoingCount: 0,
            expressBackCount: 0,
            billCount: 0,
        };
    },
    props: {
        menuList: {
            type: Array,
            required: true
        },
        beforePush: {
            type: Function
        },
        openNames: {
            type: Array
        }
    },
    updated() {
        this.$nextTick(() => {
            var dt = this.openNames;

            if (this.$refs.cpMenu) {
                // this.$refs.cpmenu.updateOpened();
            }
        });
    },
    methods: {
        goTo: function(active) {

            var cpMenu = this.$refs.cpMenu;

            let willpush = true;
            if (this.beforePush !== undefined) {
                if (!this.beforePush(active)) {
                    willpush = false;
                }
            }
            if (willpush) {
                this.$router.push({ name: active }, () => {}, (e) => {

                });
            }
            this.$emit('on-change', active);


        }

    }
}
</script>
<style>
</style>